import { ISchedulingValues } from './types';

// eslint-disable-next-line import/prefer-default-export
export function hasSelectedNewProvider(values: ISchedulingValues): boolean {
  const openingProviderId = values.opening?.provider?.id;
  const queryProviderId = values.queryProvider?.id;
  return (
    openingProviderId != null && queryProviderId != null && openingProviderId !== queryProviderId
  );
}
